<template>
  <div :class="['custom-page-card',className,isShadow ?'row-shadow':'',]">
    <div
      class="page-card-header"
      v-if="$slots.title || title"
    >
      <slot name="title">
        <p
          class="h3"
          v-html="title"
        ></p>
      </slot>
    </div>
    <el-row
      class="page-card-body"
      :gutter="gutter"
    >
      <el-col
        v-for="(col, idx) in _cardList"
        :key="col.id"
        :span="col.col"
        :offset="col.offset"
        :xs="col.xs"
        :sm="col.sm"
        :md="col.md"
        :lg="col.lg"
        :xl="col.xl"
      >
        <li
          class="card-body-list"
          v-if="!col.component"
        >
          <span
            class="list-label"
            :style="labelStyle || col&&col.labelStyle"
            v-if="col.label"
          >{{ col.label }}</span>

          <span
            class="list-value"
            :style="valueStyle || col&&col.valueStyle"
            v-if="!col.type"
          >{{
          getValue(col) | dataListFormat
        }}</span>
          <component
            v-if="col.type"
            :is="col.type"
            v-bind="col"
            v-model="col.value"
            v-on="$listeners"
          ></component>
        </li>
        <component
          v-if="col.component"
          :is="col.component"
          v-bind="col"
          v-model="col.value"
          v-on="$listeners"
        ></component>
      </el-col>
      <slot></slot>

    </el-row>
    <div
      class="page-card-footer"
      v-if="$slots.footer"
    >
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
/**
 * @description 信息卡片组件
 * @author David
 * @Date 2019/12/18
 */
import filters from '@/mixins/filters'

export default {
  name: 'custom-page-card',
  mixins: [filters],
  props: {
    title: {
      required: false,
    },
    cardList: {
      type: [Array],
      required: false,
    },
    gutter: {
      required: false,
    },
    isShadow: {
      default: false,
    },
    className: {
      required: false,
    },
    labelStyle: [Object, String],
    valueStyle: [Object, String],
  },
  computed: {
    _cardList() {
      if (this.cardList && this.cardList.length)
        return this.cardList.filter((item) => item)
      return []
    },
  },
  methods: {
    getValue(col) {
      return col && col.customValue
        ? col.customValue(col, this, this.cardList)
        : col.value
    },
  },
}
</script>

<style lang="scss" scoped>
$line-height: 40px;
.custom-page-card {
  padding: 20px;
  background-color: white;
}
.h3 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
}
.row-shadow {
  box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
  border-radius: 4px;
}
.page-card-body {
  .card-body-list {
    display: flex;
    align-items: center;
    line-height: $line-height;
  }
  .list-label {
    margin-right: 15px;
  }
  .list-label::after {
    content: '：';
  }
}
.page-card-footer {
  line-height: $line-height;
}
</style>
